<div class="brand flex-column-auto school-aside">
    <!--begin::Logo-->

    <a href="javascript:;" routerLink="/" class="brand-logo">
      <img alt="logo" class="logo" [attr.src]="headerLogo" />
    </a>
    <!--end::Logo-->
  </div>